var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qid-input" }, [
    _c("p", [
      _vm._v(
        "\n            Both single QIDs (Q146) and URLs (https://www.wikidata.org/wiki/Q146) will work.\n            Once you click 'Create query' you will get a new tab with a prefilled SPARQL query.\n        "
      ),
    ]),
    _vm._v(" "),
    _c("menu", [
      _c(
        "button",
        { attrs: { disabled: !_vm.input.length }, on: { click: _vm.create } },
        [_vm._v("Create query")]
      ),
    ]),
    _vm._v(" "),
    _c("fieldset", [
      _c("legend", [_vm._v("Options")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.addLabel,
            expression: "addLabel",
          },
        ],
        attrs: { type: "checkbox", id: "add-label" },
        domProps: {
          checked: Array.isArray(_vm.addLabel)
            ? _vm._i(_vm.addLabel, null) > -1
            : _vm.addLabel,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.addLabel,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.addLabel = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.addLabel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.addLabel = $$c
            }
          },
        },
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "add-label" } }, [_vm._v("Add label")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.addDescription,
            expression: "addDescription",
          },
        ],
        attrs: { type: "checkbox", id: "add-description" },
        domProps: {
          checked: Array.isArray(_vm.addDescription)
            ? _vm._i(_vm.addDescription, null) > -1
            : _vm.addDescription,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.addDescription,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.addDescription = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.addDescription = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.addDescription = $$c
            }
          },
        },
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "add-description" } }, [
        _vm._v("Add description"),
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "language" } }, [
        _vm._v("Language for label & description"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.language,
            expression: "language",
          },
        ],
        attrs: { type: "text", id: "language" },
        domProps: { value: _vm.language },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.language = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.skipInvalid,
            expression: "skipInvalid",
          },
        ],
        attrs: { type: "checkbox", id: "skip-invalid" },
        domProps: {
          checked: Array.isArray(_vm.skipInvalid)
            ? _vm._i(_vm.skipInvalid, null) > -1
            : _vm.skipInvalid,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.skipInvalid,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.skipInvalid = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.skipInvalid = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.skipInvalid = $$c
            }
          },
        },
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "skip-invalid" } }, [
        _vm._v("Skip invalid QIDs"),
      ]),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c("p", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.input,
          expression: "input",
        },
      ],
      attrs: {
        placeholder: "Q170486\nQ93189\nhttps://www.wikidata.org/wiki/Q606132",
        rows: "50",
      },
      domProps: { value: _vm.input },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.input = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }